import { v4 as uuidV4 } from "uuid";
import { useSelector, useDispatch } from "react-redux";

export const useSnackbar = () => {
  const messages = useSelector((state) => state.snackbar.messages);
  const dispatch = useDispatch();

  const addInfo = (message) => {
    const id = uuidV4();
    dispatch.snackbar.add({ id, message });
    setTimeout(() => {
      dispatch.snackbar.remove(id);
    }, [5_000]);
  };

  return { messages, addInfo };
};

export default useSnackbar;
